import { css } from '@emotion/react';

export const rootStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  width: 100%;
  padding: var(--spacing-3);
  border-radius: var(--radius-lg);
  box-sizing: border-box;
`;

export const variantStyles = {
  default: css`
    background: var(--surface-page);
    border: 1px solid var(--border-primary);
  `,
  muted: css`
    background: var(--surface-neutral);
    border: none;
  `,
};

export const headerStyles = css`
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  min-width: 0;
`;

export const thumbnailStyles = css`
  width: var(--spacing-14);
  height: var(--spacing-14);
  border-radius: var(--radius-md);
  object-fit: cover;
  flex-shrink: 0;
`;

export const copyStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
  min-width: 0;
`;

export const dividerStyles = css`
  margin: 0;
`;

export const footerStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-4);
`;

export const detailsListStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: 0;
`;

export const detailsListTileStyles = css`
  gap: var(--spacing-4);
`;

export const detailRowStyles = css`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  min-width: 0;
  color: var(--icon-primary);
`;

export const detailRowMultilineStyles = css`
  align-items: flex-start;
`;

export const detailCopyStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0);
  min-width: 0;
`;

export const detailIconStyles = css`
  display: inline-flex;
  flex-shrink: 0;
  color: var(--icon-primary);
`;

export const detailIconTileStyles = css`
  align-items: center;
  justify-content: center;
  width: var(--spacing-10);
  height: var(--spacing-10);
  border-radius: var(--radius-md);
  background: var(--surface-success);
`;

export const editButtonStyles = css`
  appearance: none;
  margin: 0 0 0 auto;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  color: var(--text-action);
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: var(--text-action-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: 2px;
    border-radius: var(--radius-sm);
  }
`;
